import React from "react";
import { KONTAKT } from "../config/kontakt";

export default function Datenschutz() {
  const h3 = { color: "#2e7d32", margin: "1.5rem 0 0.5rem" };

  return (
    <div className="container" style={{ maxWidth: 800 }}>
      <h2 className="section-title" style={{ marginTop: "1rem" }}>Datenschutzerklärung</h2>

      <div className="card" style={{ marginTop: "1.5rem", lineHeight: "1.9", color: "#555" }}>

        <h3 style={h3}>1. Information über die Erhebung personenbezogener Daten und Kontaktdaten des Verantwortlichen</h3>
        <p>
          <strong>1.1</strong> Wir freuen uns, dass Sie unsere Website besuchen und bedanken uns für Ihr Interesse.
          Im Folgenden informieren wir Sie über den Umgang mit Ihren personenbezogenen Daten bei der Nutzung unserer
          Website. Personenbezogene Daten sind hierbei alle Daten, mit denen Sie persönlich identifiziert werden können.
        </p>
        <br />
        <p>
          <strong>1.2</strong> Verantwortlicher für die Datenverarbeitung auf dieser Website im Sinne der
          Datenschutz-Grundverordnung (DSGVO) ist {KONTAKT.name}, {KONTAKT.strasse}, {KONTAKT.ort}, Deutschland,
          Tel.: {KONTAKT.telefonDatum}, E-Mail: {KONTAKT.email}. Der für die Verarbeitung von personenbezogenen Daten
          Verantwortliche ist diejenige natürliche oder juristische Person, die allein oder gemeinsam mit anderen über
          die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
        </p>
        <br />
        <p>
          <strong>1.3</strong> Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
          personenbezogener Daten und anderer vertraulicher Inhalte (z.B. Bestellungen oder Anfragen an den
          Verantwortlichen) eine SSL- bzw. TLS-Verschlüsselung. Sie können eine verschlüsselte Verbindung an der
          Zeichenfolge „https://" und dem Schloss-Symbol in Ihrer Browserzeile erkennen.
        </p>

        <h3 style={h3}>2. Datenerfassung beim Besuch unserer Website</h3>
        <p>
          Bei der bloß informatorischen Nutzung unserer Website, also wenn Sie sich nicht registrieren oder uns
          anderweitig Informationen übermitteln, erheben wir nur solche Daten, die Ihr Browser an unseren Server
          übermittelt (sog. „Server-Logfiles"). Wenn Sie unsere Website aufrufen, erheben wir die folgenden Daten,
          die für uns technisch erforderlich sind, um Ihnen die Website anzuzeigen:
        </p>
        <ul style={{ paddingLeft: "1.5rem", lineHeight: 2, marginTop: "0.5rem" }}>
          <li>Unsere besuchte Website</li>
          <li>Datum und Uhrzeit zum Zeitpunkt des Zugriffes</li>
          <li>Menge der gesendeten Daten in Byte</li>
          <li>Quelle/Verweis, von welchem Sie auf die Seite gelangten</li>
          <li>Verwendeter Browser</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Verwendete IP-Adresse (ggf.: in anonymisierter Form)</li>
        </ul>
        <p>
          Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an der
          Verbesserung der Stabilität und Funktionalität unserer Website. Eine Weitergabe oder anderweitige Verwendung
          der Daten findet nicht statt. Wir behalten uns allerdings vor, die Server-Logfiles nachträglich zu
          überprüfen, sollten konkrete Anhaltspunkte auf eine rechtswidrige Nutzung hinweisen.
        </p>

        <h3 style={h3}>3. Kontaktaufnahme</h3>
        <p>
          Im Rahmen der Kontaktaufnahme mit uns (z.B. per Kontaktformular oder E-Mail) werden – ausschließlich zum
          Zweck der Bearbeitung und Beantwortung Ihres Anliegens und nur im dafür erforderlichen Umfang –
          personenbezogene Daten verarbeitet. Rechtsgrundlage für die Verarbeitung dieser Daten ist unser
          berechtigtes Interesse an der Beantwortung Ihres Anliegens gemäß Art. 6 Abs. 1 lit. f DSGVO. Zielt Ihre
          Kontaktierung auf einen Vertrag ab, so ist zusätzliche Rechtsgrundlage für die Verarbeitung
          Art. 6 Abs. 1 lit. b DSGVO. Ihre Daten werden gelöscht, wenn sich aus den Umständen entnehmen lässt,
          dass der betroffene Sachverhalt abschließend geklärt ist und sofern keine gesetzlichen
          Aufbewahrungspflichten entgegenstehen.
        </p>

        <h3 style={h3}>4. Datenverarbeitung bei Eröffnung eines Kundenkontos</h3>
        <p>
          Gemäß Art. 6 Abs. 1 lit. b DSGVO werden personenbezogene Daten im jeweils erforderlichen Umfang weiterhin
          erhoben und verarbeitet, wenn Sie uns diese bei der Eröffnung eines Kundenkontos mitteilen. Welche Daten
          für die Kontoeröffnung erforderlich sind, entnehmen Sie der Eingabemaske des entsprechenden Formulars auf
          unserer Website. Eine Löschung Ihres Kundenkontos ist jederzeit möglich und kann durch eine Nachricht an
          die o.g. Adresse des Verantwortlichen erfolgen. Nach Löschung Ihres Kundenkontos werden Ihre Daten
          gelöscht, sofern alle darüber geschlossenen Verträge vollständig abgewickelt sind, keine gesetzlichen
          Aufbewahrungsfristen entgegenstehen und unsererseits kein berechtigtes Interesse an der Weiterspeicherung
          fortbesteht.
        </p>

        <h3 style={h3}>5. Datenverarbeitung zur Bestellabwicklung</h3>
        <p>
          Die von uns erhobenen personenbezogenen Daten werden zur Vertragsabwicklung (Lieferung und Rechnungsstellung)
          gemäß Art. 6 Abs. 1 lit. b DSGVO verarbeitet. Eine Weitergabe an Dritte findet nicht statt.
        </p>

        <h3 style={h3}>6. Rechte des Betroffenen</h3>
        <p>
          <strong>6.1</strong> Das geltende Datenschutzrecht gewährt Ihnen gegenüber dem Verantwortlichen
          hinsichtlich der Verarbeitung Ihrer personenbezogenen Daten die nachstehenden Betroffenenrechte:
        </p>
        <ul style={{ paddingLeft: "1.5rem", lineHeight: 2, marginTop: "0.5rem" }}>
          <li>Auskunftsrecht gemäß Art. 15 DSGVO</li>
          <li>Recht auf Berichtigung gemäß Art. 16 DSGVO</li>
          <li>Recht auf Löschung gemäß Art. 17 DSGVO</li>
          <li>Recht auf Einschränkung der Verarbeitung gemäß Art. 18 DSGVO</li>
          <li>Recht auf Unterrichtung gemäß Art. 19 DSGVO</li>
          <li>Recht auf Datenübertragbarkeit gemäß Art. 20 DSGVO</li>
          <li>Recht auf Widerruf erteilter Einwilligungen gemäß Art. 7 Abs. 3 DSGVO</li>
          <li>Recht auf Beschwerde gemäß Art. 77 DSGVO</li>
        </ul>
        <br />
        <p>
          <strong>6.2 Widerspruchsrecht</strong>
        </p>
        <p>
          Wenn wir im Rahmen einer Interessenabwägung Ihre personenbezogenen Daten aufgrund unseres überwiegenden
          berechtigten Interesses verarbeiten, haben Sie das jederzeitige Recht, aus Gründen, die sich aus Ihrer
          besonderen Situation ergeben, gegen diese Verarbeitung Widerspruch mit Wirkung für die Zukunft einzulegen.
          Machen Sie von Ihrem Widerspruchsrecht Gebrauch, beenden wir die Verarbeitung der betroffenen Daten.
          Eine Weiterverarbeitung bleibt aber vorbehalten, wenn wir zwingende schutzwürdige Gründe für die
          Verarbeitung nachweisen können, die Ihre Interessen, Grundrechte und Grundfreiheiten überwiegen, oder
          wenn die Verarbeitung der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen dient.
        </p>
        <p>
          Werden Ihre personenbezogenen Daten von uns verarbeitet, um Direktwerbung zu betreiben, haben Sie das
          Recht, jederzeit Widerspruch gegen die Verarbeitung Sie betreffender personenbezogener Daten zum Zwecke
          derartiger Werbung einzulegen. Machen Sie von Ihrem Widerspruchsrecht Gebrauch, beenden wir die
          Verarbeitung der betroffenen Daten zu Direktwerbezwecken.
        </p>

        <h3 style={h3}>7. Dauer der Speicherung personenbezogener Daten</h3>
        <p>
          Die Dauer der Speicherung von personenbezogenen Daten bemisst sich anhand der jeweiligen Rechtsgrundlage,
          am Verarbeitungszweck und – sofern einschlägig – zusätzlich anhand der jeweiligen gesetzlichen
          Aufbewahrungsfrist (z.B. handels- und steuerrechtliche Aufbewahrungsfristen).
        </p>
        <p>
          Existieren gesetzliche Aufbewahrungsfristen für Daten, die im Rahmen rechtsgeschäftlicher
          Verpflichtungen auf der Grundlage von Art. 6 Abs. 1 lit. b DSGVO verarbeitet werden, werden diese Daten
          nach Ablauf der Aufbewahrungsfristen routinemäßig gelöscht, sofern sie nicht mehr zur Vertragserfüllung
          oder Vertragsanbahnung erforderlich sind.
        </p>
        <p>
          Sofern sich aus den sonstigen Informationen dieser Erklärung über spezifische Verarbeitungssituationen
          nichts anderes ergibt, werden gespeicherte personenbezogene Daten im Übrigen dann gelöscht, wenn sie für
          die Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig sind.
        </p>

      </div>
    </div>
  );
}
